// services/employeeService.js
import { employeesAPI } from './api';

export const employeeService = {
  async getEmployees() {
    try {
      const response = await employeesAPI.getAll();
      return response.data;
    } catch (error) {
      console.error('❌ Error fetching employees:', error);
      throw new Error(error.response?.data?.message || 'Failed to load employees');
    }
  },

  async getEmployee(id) {
    try {
      const response = await employeesAPI.getById(id);
      return response.data;
    } catch (error) {
      console.error('❌ Error fetching employee:', error);
      throw new Error(error.response?.data?.message || 'Failed to load employee');
    }
  },

  async createEmployee(employee) {
    try {
      console.log('📤 Creating employee:', employee);
      const response = await employeesAPI.create(employee);
      console.log('✅ Employee created:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Error creating employee:', error);
      const errorMessage = error.response?.data?.title || 
                          error.response?.data?.message || 
                          error.response?.data || 
                          'Failed to create employee';
      throw new Error(errorMessage);
    }
  },

  async updateEmployee(id, employee) {
    try {
      console.log(`📤 Updating employee ${id}:`, employee);
      const response = await employeesAPI.update(id, employee);
      console.log('✅ Employee updated:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Error updating employee:', error);
      const errorMessage = error.response?.data?.title || 
                          error.response?.data?.message || 
                          error.response?.data || 
                          'Failed to update employee';
      throw new Error(errorMessage);
    }
  },

  async deleteEmployee(id) {
    try {
      await employeesAPI.delete(id);
    } catch (error) {
      console.error('❌ Error deleting employee:', error);
      throw new Error(error.response?.data?.message || 'Failed to delete employee');
    }
  },

  async downloadTemplate() {
    try {
      const response = await employeesAPI.get('/template', {
        responseType: 'blob'
      });
      return response.data;
    } catch (error) {
      console.error('❌ Error downloading template:', error);
      throw new Error(error.response?.data?.message || 'Failed to download template');
    }
  },

  async uploadEmployees(file) {
    try {
      const formData = new FormData();
      formData.append('file', file);

      const response = await employeesAPI.post('/upload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (error) {
      console.error('❌ Error uploading employees:', error);
      throw new Error(error.response?.data?.message || 'Failed to upload employees');
    }
  }
};